import { createSlice } from "@reduxjs/toolkit";
import cookie from "react-cookies";


const initialState = {
    status: 'initial',
    errorMessage: '',
    isLoggedIn: false,
    user: {},
    token: '',
    sentEmail:false,
    otpVerify:false,
}

const authReducer = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loadingAuth(state) {
            state.status = 'loading';
            state.user = {};
            state.token = '';
        },
        loadingSendAuth(state) {
            state.status = 'loading';
            state.sentEmail = false;
            // state.user = {};
            // state.token = '';
        },
        loadingOtpAuth(state) {
            state.status = 'loading';
            state.otpVerify = false;
            // state.user = {};
            // state.token = '';
        },
        failedSendAuth(state,action) {
            state.status = 'error';
            state.sentEmail = false;
            state.errorMessage = action.payload?.message;
            // state.user = {};
            // state.token = '';
        },
        failedOtpAuth(state,action) {
            state.status = 'error';
            state.otpVerify = false;
            state.errorMessage = action.payload?.message;
            // state.user = {};
            // state.token = '';
        },
        successSendAuth(state) {
            state.status = 'success';
            state.sentEmail = true;
            // state.user = {};
            // state.token = '';
        },
        successOtpAuth(state,action) {
            state.status = 'success';
            state.otpVerify = true;
            state.user = action.payload;
            // state.token = '';
        },
        successAuth(state, action) {
            state.status = 'success';
            // console.log(action.payload?.token);
            cookie.save('token',action.payload?.token,{
                maxAge: 24 * 60 * 60,
            });
            state.user = action.payload?.user;
            state.token = action.payload?.token;
            state.isLoggedIn = true;
        },
        failedAuth(state, action) {
            console.log(action);
            // cookie.remove('token');
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            state.status = 'error';
            state.errorMessage = action.payload?.message;
            state.user = {};
            state.token = '';
            state.isLoggedIn = false;
        },
        logOutAuth(state){
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            // cookie.remove('token');
            state.isLoggedIn = false;
            state.token='';
            state.user={};
        }
    },
});

export default authReducer.reducer;

export const { loadingAuth,logOutAuth, successAuth, failedAuth,loadingSendAuth,successSendAuth,failedSendAuth,loadingOtpAuth,successOtpAuth,failedOtpAuth } = authReducer.actions;